import * as React from 'react';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import Articles from '../components/landing/Articles';
import ContactCTA from '../components/landing/ContactCTA';
import { ContentClassroom } from '../components/landing/Content';
import { FAQClassroom } from '../components/landing/FAQ';
import FeaturesClassroom from '../components/landing/FeaturesClassroom';
import { HeroClassroom } from '../components/landing/Hero';
import { HowItWorksClassroom } from '../components/landing/HowItWorks';
import Pricing from '../components/landing/Pricing';
import { PrintExamplesClassroom } from '../components/landing/PrintExamples';
import { TestimonialsClassroom } from '../components/landing/Testimonials';
import UseCases from '../components/landing/UseCases';

const IndexPage = () => (
  <>
    <HeroClassroom />
    <TestimonialsClassroom />
    <HowItWorksClassroom />
    <FeaturesClassroom />
    <ContentClassroom />
    <PrintExamplesClassroom />
    <Pricing />
    <FAQClassroom />
    <Articles />
    <UseCases />
    <ContactCTA />
    <Footer />
  </>
);

export const Head = () => (
  <SEO
    title="Seating Chart Maker | Generate Classroom Seating Plans"
    description="Create seating charts for school classrooms. 1. Create or import a roster. 2. Arrange chairs. 3. Generate a seating chart (random or drag&drop). Share or print!"
  />
);

export default IndexPage;
